import _ from 'lodash'

export type TestimonialQuote = {
  index: number
  src: string
  alt: string
  quote: string
  author: string
  role: string
}

const testimonials: TestimonialQuote[] = [
  // NOTE: add new testimonial here
  // {
  //   index: 0,
  //   src: '',
  //   alt: '',
  //   quote: '',
  //   author: '',
  //   role: '',
  // },
  {
    index: 1,
    src: '/images/testimonial/tomas-ondrejka-300x300.jpg',
    alt: 'Photo of Tomas Ondrejka',
    quote: 'marketing-pages-common.testimonial-text-1',
    author: 'marketing-pages-common.testimonial-author-1',
    role: 'marketing-pages-common.testimonial-role-1',
  },
  {
    index: 2,
    src: '/images/testimonial/tom-revill-350x350.jpg',
    alt: 'Photo of Tom Revill',
    quote: 'marketing-pages-common.testimonial-text-2',
    author: 'marketing-pages-common.testimonial-author-2',
    role: 'marketing-pages-common.testimonial-role-2',
  },
  {
    index: 3,
    src: '/images/testimonial/liviu-ghiban-300x300.jpg',
    alt: 'Photo of Liviu Mirea-Ghiban',
    quote: 'marketing-pages-common.testimonial-text-3',
    author: 'marketing-pages-common.testimonial-author-3',
    role: 'marketing-pages-common.testimonial-role-3',
  },
  {
    index: 4,
    src: '/images/testimonial/jakub-jurovych-350x350.jpg',
    alt: 'Photo of Jakub Jurovych',
    quote: 'marketing-pages-common.testimonial-text-4',
    author: 'marketing-pages-common.testimonial-author-4',
    role: 'marketing-pages-common.testimonial-role-4',
  },
  {
    index: 5,
    src: '/images/testimonial/matej-ftacnik-300x300.jpg',
    alt: 'Photo of Matej Ftacnik',
    quote: 'marketing-pages-common.testimonial-text-5',
    author: 'marketing-pages-common.testimonial-author-5',
    role: 'marketing-pages-common.testimonial-role-5',
  },
  {
    index: 6,
    src: '/images/testimonial/rob-curtis-350x350.jpg',
    alt: 'Photo of Rob Curtis',
    quote: 'marketing-pages-common.testimonial-text-6',
    author: 'marketing-pages-common.testimonial-author-6',
    role: 'marketing-pages-common.testimonial-role-6',
  },
  {
    index: 7,
    src: '/images/testimonial/jozef-maruscak-350x350.jpg',
    alt: 'Photo of Jozef Maruscak',
    quote: 'marketing-pages-common.testimonial-text-7',
    author: 'marketing-pages-common.testimonial-author-7',
    role: 'marketing-pages-common.testimonial-role-7',
  },
  {
    index: 8,
    src: '/images/testimonial/ondrej-materna-350x350.jpg',
    alt: 'Photo of Ondrej Materna',
    quote: 'marketing-pages-common.testimonial-text-8',
    author: 'marketing-pages-common.testimonial-author-8',
    role: 'marketing-pages-common.testimonial-role-8',
  },
  {
    index: 9,
    src: '/images/testimonial/samuel-bednar-300x300.jpg',
    alt: 'Photo of Samuel Bednar',
    quote: 'marketing-pages-common.testimonial-text-9',
    author: 'marketing-pages-common.testimonial-author-9',
    role: 'marketing-pages-common.testimonial-role-9',
  },
  {
    index: 10,
    src: '/images/testimonial/michaela-siskova-350x350.jpg',
    alt: 'Photo of Michaela Siskova',
    quote: 'marketing-pages-common.testimonial-text-10',
    author: 'marketing-pages-common.testimonial-author-10',
    role: 'marketing-pages-common.testimonial-role-10',
  },
  {
    index: 11,
    src: '/images/testimonial/andrej-hano-350x350.jpg',
    alt: 'Photo of Andrej Hano',
    quote: 'marketing-pages-common.testimonial-text-11',
    author: 'marketing-pages-common.testimonial-author-11',
    role: 'marketing-pages-common.testimonial-role-11',
  },
  {
    index: 12,
    src: '/images/testimonial/david-adderson-350x350.jpg',
    alt: 'Photo of David Adderson',
    quote: 'marketing-pages-common.testimonial-text-12',
    author: 'marketing-pages-common.testimonial-author-12',
    role: 'marketing-pages-common.testimonial-role-12',
  },
]

const orderDefault = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const testimonialsList = _.sortBy(testimonials, ({index}) => orderDefault.indexOf(index))

export const useTestimonialsContent = () => ({
  title: 'testimonial-title',
  list: testimonialsList,
})
